"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var hooks_1 = require("containers/Settings/Users/hooks");
var SuspendBtn = function (_a) {
    var item = _a.item;
    var _b = __read((0, hooks_1.useUpdateUser)(item.id), 2), userSubmitter = _b[0], isSubmitting = _b[1];
    var handleSuspend = function () { return userSubmitter({ isSuspended: !(item === null || item === void 0 ? void 0 : item.isSuspended) }); };
    return ((0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ onClick: handleSuspend, isSending: isSubmitting }, { children: isSubmitting ? 'Submitting...' : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [" ", item.isSuspended ? 'Activate' : 'Suspend', " "] }) })));
};
exports.default = SuspendBtn;
